import BaseParagraph from "./baseParagraph";
import useColors from "../customHooks/useColors";

const BaseRadioButton = ({
  value = null,
  onChange = () => {},
  elements = [],
  radioButtonStyle = {},
  name,
  translate = true,
}) => {
  const [currentColors] = useColors();
  return (
    <>
      <BaseParagraph>chooseTypeOfCommunication</BaseParagraph>
      {elements.map((element) => {
        return (
          <div
            key={element.value}
            style={{ display: "flex", flexDirection: "row" }}
          >
            <input
              style={{
                ...radioButtonStyle,
                marginRight: "3%",
                accentColor: currentColors.primary,
                cursor: "pointer",
              }}
              type="radio"
              name={name}
              value={(value ?? "") === (element.value ?? "")}
              checked={(value ?? "") === (element.value ?? "")}
              onChange={() => {
                onChange(element.value);
              }}
            />
            <label>
              <BaseParagraph
                onClick={() => onChange(element.value)}
                translate={translate}
                style={{ cursor: "pointer" }}
              >
                {element.name}
              </BaseParagraph>
            </label>
          </div>
        );
      })}
    </>
  );
};

export default BaseRadioButton;
